import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Setup2FA from './pages/Setup2FA';

import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ComplaintDetail from './pages/ComplaintDetail';
import ComplaintChat from './pages/ComplaintChat';
import Analytics from './pages/Analytics';
import Profile from './pages/Profile';
import Verify2FA from './pages/Verify2FA';
import SuggestionDetail from "./pages/SuggestionDetail";


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">

          <Routes>

            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-2fa" element={<Verify2FA />} />

            {/* Dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* Complaint Detail */}
           <Route
  path="/detail/:type/:id"
  element={
    <PrivateRoute>
      <Layout>
        <ComplaintDetail />
      </Layout>
    </PrivateRoute>
  }
/>

<Route
  path="/detail/suggestion/:id"
  element={
    <PrivateRoute>
      <SuggestionDetail />
    </PrivateRoute>
  }
/>

            {/* Complaint Chat */}
            <Route
              path="/complaint-chat/:complaintId"
              element={
                <PrivateRoute>
                  <Layout>
                    <ComplaintChat />
                  </Layout>
                </PrivateRoute>
              }
            />

            <Route
  path="/setup-2fa"
  element={<Setup2FA />}
/>

    

            {/* Analytics */}
            <Route
              path="/analytics"
              element={
                <PrivateRoute>
                  <Layout>
                    <Analytics />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* Profile */}
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Layout>
                    <Profile />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* Default Routes */}
            <Route
              path="/"
              element={<Navigate to="/dashboard" replace />}
            />

            <Route
              path="*"
              element={<Navigate to="/dashboard" replace />}
            />

          </Routes>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
          />

        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;